// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { AppointmentPublicConfirmData, AppointmentPublicConfirmResponses, AppointmentPublicConfirmErrors, AppointmentPublicCancelData, AppointmentPublicCancelResponses, AppointmentPublicCancelErrors, AppointmentIndexData, AppointmentIndexResponses, AppointmentIndexErrors, AppointmentCalendarData, AppointmentCalendarResponses, AppointmentCalendarErrors, AppointmentMetadataData, AppointmentMetadataResponses, AppointmentMetadataErrors, AppointmentSlotsData, AppointmentSlotsResponses, AppointmentSlotsErrors, AppointmentNextAvailableDateData, AppointmentNextAvailableDateResponses, AppointmentNextAvailableDateErrors, AppointmentCreateData, AppointmentCreateResponses, AppointmentCreateErrors, AppointmentDestroyData, AppointmentDestroyResponses, AppointmentDestroyErrors, AppointmentShowData, AppointmentShowResponses, AppointmentShowErrors, AppointmentUpdateData, AppointmentUpdateResponses, AppointmentUpdateErrors, AppointmentCancelData, AppointmentCancelResponses, AppointmentCancelErrors, AppointmentRescheduleData, AppointmentRescheduleResponses, AppointmentRescheduleErrors, AuthLoginData, AuthLoginResponses, AuthLoginErrors, AuthForgotPasswordData, AuthForgotPasswordResponses, AuthForgotPasswordErrors, AuthResetPasswordData, AuthResetPasswordResponses, AuthResetPasswordErrors, AuthUserData, AuthUserResponses, AuthUserErrors, AuthLogOutData, AuthLogOutResponses, AuthLogOutErrors, ClientIndexData, ClientIndexResponses, ClientIndexErrors, ClientStoreData, ClientStoreResponses, ClientStoreErrors, ClientDeleteData, ClientDeleteResponses, ClientDeleteErrors, ClientShowData, ClientShowResponses, ClientShowErrors, ClientUpdateData, ClientUpdateResponses, ClientUpdateErrors, CoatTypeIndexData, CoatTypeIndexResponses, CoatTypeIndexErrors, CoatTypeStoreData, CoatTypeStoreResponses, CoatTypeStoreErrors, CoatTypeDeleteData, CoatTypeDeleteResponses, CoatTypeDeleteErrors, CoatTypeShowData, CoatTypeShowResponses, CoatTypeShowErrors, CoatTypeUpdateData, CoatTypeUpdateResponses, CoatTypeUpdateErrors, ContactSubmissionStoreData, ContactSubmissionStoreResponses, ContactSubmissionStoreErrors, InvitationSendVerificationCodeData, InvitationSendVerificationCodeResponses, InvitationSendVerificationCodeErrors, InvitationVerifyData, InvitationVerifyResponses, InvitationVerifyErrors, InvitationShowData, InvitationShowResponses, InvitationRegisterData, InvitationRegisterErrors, InvitationIndexData, InvitationIndexResponses, InvitationIndexErrors, InvitationStoreData, InvitationStoreResponses, InvitationStoreErrors, InvitationDeleteData, InvitationDeleteResponses, InvitationDeleteErrors, LocationIndexData, LocationIndexResponses, LocationIndexErrors, LocationStoreData, LocationStoreResponses, LocationStoreErrors, LocationDeleteData, LocationDeleteResponses, LocationDeleteErrors, LocationShowData, LocationShowResponses, LocationShowErrors, LocationUpdateData, LocationUpdateResponses, LocationUpdateErrors, MediaGenerateUploadUrlData, MediaGenerateUploadUrlResponses, MediaGenerateUploadUrlErrors, NewsletterStoreData, NewsletterStoreResponses, NewsletterStoreErrors, PetIndexData, PetIndexResponses, PetIndexErrors, PetStoreData, PetStoreResponses, PetStoreErrors, PetDeleteData, PetDeleteResponses, PetDeleteErrors, PetShowData, PetShowResponses, PetShowErrors, PetUpdateData, PetUpdateResponses, PetUpdateErrors, ScheduleShowData, ScheduleShowResponses, ScheduleShowErrors, ScheduleUpdateData, ScheduleUpdateResponses, ScheduleUpdateErrors, ServiceIndexData, ServiceIndexResponses, ServiceIndexErrors, ServiceStoreData, ServiceStoreResponses, ServiceStoreErrors, ServiceDeleteData, ServiceDeleteResponses, ServiceDeleteErrors, ServiceShowData, ServiceShowResponses, ServiceShowErrors, ServiceUpdateData, ServiceUpdateResponses, ServiceUpdateErrors, ServiceVariantIndexData, ServiceVariantIndexResponses, ServiceVariantIndexErrors, ServiceVariantSyncData, ServiceVariantSyncResponses, ServiceVariantSyncErrors, SizeCategoryIndexData, SizeCategoryIndexResponses, SizeCategoryIndexErrors, SizeCategoryStoreData, SizeCategoryStoreResponses, SizeCategoryStoreErrors, SizeCategoryDeleteData, SizeCategoryDeleteResponses, SizeCategoryDeleteErrors, SizeCategoryShowData, SizeCategoryShowResponses, SizeCategoryShowErrors, SizeCategoryUpdateData, SizeCategoryUpdateResponses, SizeCategoryUpdateErrors, SmsCreditsIndexData, SmsCreditsIndexResponses, SmsCreditsIndexErrors, SmsCreditsTransactionsData, SmsCreditsTransactionsResponses, SmsCreditsTransactionsErrors, SmsCreditsCheckoutData, SmsCreditsCheckoutResponses, SmsCreditsCheckoutErrors, StripeWebhookHandleData, StripeWebhookHandleResponses, SupportTicketStoreData, SupportTicketStoreResponses, SupportTicketStoreErrors, TelnyxWebhookHandleData, TelnyxWebhookHandleResponses, TelnyxWebhookHandleErrors, TenantIndexData, TenantIndexResponses, TenantIndexErrors, TenantShowByBookingUrlData, TenantShowByBookingUrlResponses, TenantActiveData, TenantActiveResponses, TenantActiveErrors, TenantUpdateData, TenantUpdateResponses, TenantUpdateErrors, TenantOnboardingRegisterData, TenantOnboardingRegisterResponses, TenantOnboardingRegisterErrors, TenantOnboardingUpdateData, TenantOnboardingUpdateResponses, TenantOnboardingUpdateErrors, TutorialCompleteData, TutorialCompleteResponses, TutorialCompleteErrors, UserIndexData, UserIndexResponses, UserIndexErrors, UserDeleteData, UserDeleteResponses, UserDeleteErrors, UserShowData, UserShowResponses, UserShowErrors, UserUpdateData, UserUpdateResponses, UserUpdateErrors } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const appointmentPublicConfirm = <ThrowOnError extends boolean = false>(options: Options<AppointmentPublicConfirmData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppointmentPublicConfirmResponses, AppointmentPublicConfirmErrors, ThrowOnError>({
        url: '/appointments/{id}/confirm',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appointmentPublicCancel = <ThrowOnError extends boolean = false>(options: Options<AppointmentPublicCancelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppointmentPublicCancelResponses, AppointmentPublicCancelErrors, ThrowOnError>({
        url: '/appointments/{id}/cancel',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appointmentIndex = <ThrowOnError extends boolean = false>(options?: Options<AppointmentIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppointmentIndexResponses, AppointmentIndexErrors, ThrowOnError>({
        url: '/appointments',
        ...options
    });
};

export const appointmentCalendar = <ThrowOnError extends boolean = false>(options?: Options<AppointmentCalendarData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AppointmentCalendarResponses, AppointmentCalendarErrors, ThrowOnError>({
        url: '/appointments/calendar',
        ...options
    });
};

export const appointmentMetadata = <ThrowOnError extends boolean = false>(options: Options<AppointmentMetadataData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppointmentMetadataResponses, AppointmentMetadataErrors, ThrowOnError>({
        url: '/appointments/metadata',
        ...options
    });
};

export const appointmentSlots = <ThrowOnError extends boolean = false>(options: Options<AppointmentSlotsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppointmentSlotsResponses, AppointmentSlotsErrors, ThrowOnError>({
        url: '/appointments/slots',
        ...options
    });
};

export const appointmentNextAvailableDate = <ThrowOnError extends boolean = false>(options: Options<AppointmentNextAvailableDateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppointmentNextAvailableDateResponses, AppointmentNextAvailableDateErrors, ThrowOnError>({
        url: '/appointments/next-available-date',
        ...options
    });
};

export const appointmentCreate = <ThrowOnError extends boolean = false>(options: Options<AppointmentCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppointmentCreateResponses, AppointmentCreateErrors, ThrowOnError>({
        url: '/appointments/create',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appointmentDestroy = <ThrowOnError extends boolean = false>(options: Options<AppointmentDestroyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<AppointmentDestroyResponses, AppointmentDestroyErrors, ThrowOnError>({
        url: '/appointments/{id}',
        ...options
    });
};

export const appointmentShow = <ThrowOnError extends boolean = false>(options: Options<AppointmentShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AppointmentShowResponses, AppointmentShowErrors, ThrowOnError>({
        url: '/appointments/{id}',
        ...options
    });
};

export const appointmentUpdate = <ThrowOnError extends boolean = false>(options: Options<AppointmentUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AppointmentUpdateResponses, AppointmentUpdateErrors, ThrowOnError>({
        url: '/appointments/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const appointmentCancel = <ThrowOnError extends boolean = false>(options: Options<AppointmentCancelData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AppointmentCancelResponses, AppointmentCancelErrors, ThrowOnError>({
        url: '/appointments/{id}',
        ...options
    });
};

export const appointmentReschedule = <ThrowOnError extends boolean = false>(options: Options<AppointmentRescheduleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AppointmentRescheduleResponses, AppointmentRescheduleErrors, ThrowOnError>({
        url: '/appointments/{id}/reschedule',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authLogin = <ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authForgotPassword = <ThrowOnError extends boolean = false>(options: Options<AuthForgotPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthForgotPasswordResponses, AuthForgotPasswordErrors, ThrowOnError>({
        url: '/auth/forgot-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthResetPasswordData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthResetPasswordResponses, AuthResetPasswordErrors, ThrowOnError>({
        url: '/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authUser = <ThrowOnError extends boolean = false>(options?: Options<AuthUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthUserResponses, AuthUserErrors, ThrowOnError>({
        url: '/auth/user',
        ...options
    });
};

export const authLogOut = <ThrowOnError extends boolean = false>(options?: Options<AuthLogOutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthLogOutResponses, AuthLogOutErrors, ThrowOnError>({
        url: '/auth/logout',
        ...options
    });
};

export const clientIndex = <ThrowOnError extends boolean = false>(options?: Options<ClientIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ClientIndexResponses, ClientIndexErrors, ThrowOnError>({
        url: '/clients',
        ...options
    });
};

export const clientStore = <ThrowOnError extends boolean = false>(options: Options<ClientStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClientStoreResponses, ClientStoreErrors, ThrowOnError>({
        url: '/clients',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const clientDelete = <ThrowOnError extends boolean = false>(options: Options<ClientDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ClientDeleteResponses, ClientDeleteErrors, ThrowOnError>({
        url: '/clients/{id}',
        ...options
    });
};

export const clientShow = <ThrowOnError extends boolean = false>(options: Options<ClientShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ClientShowResponses, ClientShowErrors, ThrowOnError>({
        url: '/clients/{id}',
        ...options
    });
};

/**
 * ⚠️Cannot generate request documentation: Call to a member function unique() on null
 */
export const clientUpdate = <ThrowOnError extends boolean = false>(options: Options<ClientUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ClientUpdateResponses, ClientUpdateErrors, ThrowOnError>({
        url: '/clients/{client}',
        ...options
    });
};

export const coatTypeIndex = <ThrowOnError extends boolean = false>(options?: Options<CoatTypeIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<CoatTypeIndexResponses, CoatTypeIndexErrors, ThrowOnError>({
        url: '/coat-types',
        ...options
    });
};

export const coatTypeStore = <ThrowOnError extends boolean = false>(options: Options<CoatTypeStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CoatTypeStoreResponses, CoatTypeStoreErrors, ThrowOnError>({
        url: '/coat-types',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const coatTypeDelete = <ThrowOnError extends boolean = false>(options: Options<CoatTypeDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CoatTypeDeleteResponses, CoatTypeDeleteErrors, ThrowOnError>({
        url: '/coat-types/{coatType}',
        ...options
    });
};

export const coatTypeShow = <ThrowOnError extends boolean = false>(options: Options<CoatTypeShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CoatTypeShowResponses, CoatTypeShowErrors, ThrowOnError>({
        url: '/coat-types/{coatType}',
        ...options
    });
};

export const coatTypeUpdate = <ThrowOnError extends boolean = false>(options: Options<CoatTypeUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CoatTypeUpdateResponses, CoatTypeUpdateErrors, ThrowOnError>({
        url: '/coat-types/{coatType}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const contactSubmissionStore = <ThrowOnError extends boolean = false>(options: Options<ContactSubmissionStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ContactSubmissionStoreResponses, ContactSubmissionStoreErrors, ThrowOnError>({
        url: '/contact',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationSendVerificationCode = <ThrowOnError extends boolean = false>(options: Options<InvitationSendVerificationCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InvitationSendVerificationCodeResponses, InvitationSendVerificationCodeErrors, ThrowOnError>({
        url: '/invitations/verification-code',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationVerify = <ThrowOnError extends boolean = false>(options: Options<InvitationVerifyData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InvitationVerifyResponses, InvitationVerifyErrors, ThrowOnError>({
        url: '/invitations/verify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationShow = <ThrowOnError extends boolean = false>(options: Options<InvitationShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InvitationShowResponses, unknown, ThrowOnError>({
        url: '/invitations/{token}',
        ...options
    });
};

export const invitationRegister = <ThrowOnError extends boolean = false>(options: Options<InvitationRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<unknown, InvitationRegisterErrors, ThrowOnError>({
        url: '/invitations/{token}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationIndex = <ThrowOnError extends boolean = false>(options?: Options<InvitationIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<InvitationIndexResponses, InvitationIndexErrors, ThrowOnError>({
        url: '/invitations',
        ...options
    });
};

export const invitationStore = <ThrowOnError extends boolean = false>(options: Options<InvitationStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InvitationStoreResponses, InvitationStoreErrors, ThrowOnError>({
        url: '/invitations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationDelete = <ThrowOnError extends boolean = false>(options: Options<InvitationDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<InvitationDeleteResponses, InvitationDeleteErrors, ThrowOnError>({
        url: '/invitations/{id}',
        ...options
    });
};

export const locationIndex = <ThrowOnError extends boolean = false>(options?: Options<LocationIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LocationIndexResponses, LocationIndexErrors, ThrowOnError>({
        url: '/locations',
        ...options
    });
};

export const locationStore = <ThrowOnError extends boolean = false>(options: Options<LocationStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LocationStoreResponses, LocationStoreErrors, ThrowOnError>({
        url: '/locations',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const locationDelete = <ThrowOnError extends boolean = false>(options: Options<LocationDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LocationDeleteResponses, LocationDeleteErrors, ThrowOnError>({
        url: '/locations/{location}',
        ...options
    });
};

export const locationShow = <ThrowOnError extends boolean = false>(options: Options<LocationShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LocationShowResponses, LocationShowErrors, ThrowOnError>({
        url: '/locations/{location}',
        ...options
    });
};

export const locationUpdate = <ThrowOnError extends boolean = false>(options: Options<LocationUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<LocationUpdateResponses, LocationUpdateErrors, ThrowOnError>({
        url: '/locations/{location}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const mediaGenerateUploadUrl = <ThrowOnError extends boolean = false>(options: Options<MediaGenerateUploadUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MediaGenerateUploadUrlResponses, MediaGenerateUploadUrlErrors, ThrowOnError>({
        url: '/media/upload-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const newsletterStore = <ThrowOnError extends boolean = false>(options: Options<NewsletterStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<NewsletterStoreResponses, NewsletterStoreErrors, ThrowOnError>({
        url: '/newsletter',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const petIndex = <ThrowOnError extends boolean = false>(options?: Options<PetIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<PetIndexResponses, PetIndexErrors, ThrowOnError>({
        url: '/pets',
        ...options
    });
};

export const petStore = <ThrowOnError extends boolean = false>(options: Options<PetStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PetStoreResponses, PetStoreErrors, ThrowOnError>({
        url: '/pets',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const petDelete = <ThrowOnError extends boolean = false>(options: Options<PetDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<PetDeleteResponses, PetDeleteErrors, ThrowOnError>({
        url: '/pets/{pet}',
        ...options
    });
};

export const petShow = <ThrowOnError extends boolean = false>(options: Options<PetShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<PetShowResponses, PetShowErrors, ThrowOnError>({
        url: '/pets/{pet}',
        ...options
    });
};

export const petUpdate = <ThrowOnError extends boolean = false>(options: Options<PetUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<PetUpdateResponses, PetUpdateErrors, ThrowOnError>({
        url: '/pets/{pet}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const scheduleShow = <ThrowOnError extends boolean = false>(options: Options<ScheduleShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ScheduleShowResponses, ScheduleShowErrors, ThrowOnError>({
        url: '/schedules/{userId}',
        ...options
    });
};

export const scheduleUpdate = <ThrowOnError extends boolean = false>(options: Options<ScheduleUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ScheduleUpdateResponses, ScheduleUpdateErrors, ThrowOnError>({
        url: '/schedules/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const serviceIndex = <ThrowOnError extends boolean = false>(options?: Options<ServiceIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ServiceIndexResponses, ServiceIndexErrors, ThrowOnError>({
        url: '/services',
        ...options
    });
};

export const serviceStore = <ThrowOnError extends boolean = false>(options: Options<ServiceStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ServiceStoreResponses, ServiceStoreErrors, ThrowOnError>({
        url: '/services',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const serviceDelete = <ThrowOnError extends boolean = false>(options: Options<ServiceDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ServiceDeleteResponses, ServiceDeleteErrors, ThrowOnError>({
        url: '/services/{id}',
        ...options
    });
};

export const serviceShow = <ThrowOnError extends boolean = false>(options: Options<ServiceShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServiceShowResponses, ServiceShowErrors, ThrowOnError>({
        url: '/services/{id}',
        ...options
    });
};

export const serviceUpdate = <ThrowOnError extends boolean = false>(options: Options<ServiceUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ServiceUpdateResponses, ServiceUpdateErrors, ThrowOnError>({
        url: '/services/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const serviceVariantIndex = <ThrowOnError extends boolean = false>(options: Options<ServiceVariantIndexData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ServiceVariantIndexResponses, ServiceVariantIndexErrors, ThrowOnError>({
        url: '/service-variants/{serviceId}',
        ...options
    });
};

export const serviceVariantSync = <ThrowOnError extends boolean = false>(options: Options<ServiceVariantSyncData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<ServiceVariantSyncResponses, ServiceVariantSyncErrors, ThrowOnError>({
        url: '/service-variants/{serviceId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const sizeCategoryIndex = <ThrowOnError extends boolean = false>(options?: Options<SizeCategoryIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SizeCategoryIndexResponses, SizeCategoryIndexErrors, ThrowOnError>({
        url: '/size-categories',
        ...options
    });
};

export const sizeCategoryStore = <ThrowOnError extends boolean = false>(options: Options<SizeCategoryStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SizeCategoryStoreResponses, SizeCategoryStoreErrors, ThrowOnError>({
        url: '/size-categories',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const sizeCategoryDelete = <ThrowOnError extends boolean = false>(options: Options<SizeCategoryDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<SizeCategoryDeleteResponses, SizeCategoryDeleteErrors, ThrowOnError>({
        url: '/size-categories/{sizeCategory}',
        ...options
    });
};

export const sizeCategoryShow = <ThrowOnError extends boolean = false>(options: Options<SizeCategoryShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SizeCategoryShowResponses, SizeCategoryShowErrors, ThrowOnError>({
        url: '/size-categories/{sizeCategory}',
        ...options
    });
};

export const sizeCategoryUpdate = <ThrowOnError extends boolean = false>(options: Options<SizeCategoryUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<SizeCategoryUpdateResponses, SizeCategoryUpdateErrors, ThrowOnError>({
        url: '/size-categories/{sizeCategory}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const smsCreditsIndex = <ThrowOnError extends boolean = false>(options?: Options<SmsCreditsIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SmsCreditsIndexResponses, SmsCreditsIndexErrors, ThrowOnError>({
        url: '/sms-credits',
        ...options
    });
};

export const smsCreditsTransactions = <ThrowOnError extends boolean = false>(options?: Options<SmsCreditsTransactionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SmsCreditsTransactionsResponses, SmsCreditsTransactionsErrors, ThrowOnError>({
        url: '/sms-credits/transactions',
        ...options
    });
};

export const smsCreditsCheckout = <ThrowOnError extends boolean = false>(options: Options<SmsCreditsCheckoutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SmsCreditsCheckoutResponses, SmsCreditsCheckoutErrors, ThrowOnError>({
        url: '/sms-credits/checkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Handle Stripe webhooks
 */
export const stripeWebhookHandle = <ThrowOnError extends boolean = false>(options?: Options<StripeWebhookHandleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<StripeWebhookHandleResponses, unknown, ThrowOnError>({
        url: '/stripe/webhook',
        ...options
    });
};

export const supportTicketStore = <ThrowOnError extends boolean = false>(options: Options<SupportTicketStoreData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SupportTicketStoreResponses, SupportTicketStoreErrors, ThrowOnError>({
        url: '/support',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const telnyxWebhookHandle = <ThrowOnError extends boolean = false>(options?: Options<TelnyxWebhookHandleData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TelnyxWebhookHandleResponses, TelnyxWebhookHandleErrors, ThrowOnError>({
        url: '/telnyx/webhook',
        ...options
    });
};

export const tenantIndex = <ThrowOnError extends boolean = false>(options?: Options<TenantIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantIndexResponses, TenantIndexErrors, ThrowOnError>({
        url: '/tenants',
        ...options
    });
};

export const tenantShowByBookingUrl = <ThrowOnError extends boolean = false>(options: Options<TenantShowByBookingUrlData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TenantShowByBookingUrlResponses, unknown, ThrowOnError>({
        url: '/tenants/booking/{bookingUrl}',
        ...options
    });
};

export const tenantActive = <ThrowOnError extends boolean = false>(options?: Options<TenantActiveData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<TenantActiveResponses, TenantActiveErrors, ThrowOnError>({
        url: '/tenants/active',
        ...options
    });
};

export const tenantUpdate = <ThrowOnError extends boolean = false>(options: Options<TenantUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TenantUpdateResponses, TenantUpdateErrors, ThrowOnError>({
        url: '/tenants/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const tenantOnboardingRegister = <ThrowOnError extends boolean = false>(options: Options<TenantOnboardingRegisterData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantOnboardingRegisterResponses, TenantOnboardingRegisterErrors, ThrowOnError>({
        url: '/auth/register',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const tenantOnboardingUpdate = <ThrowOnError extends boolean = false>(options: Options<TenantOnboardingUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TenantOnboardingUpdateResponses, TenantOnboardingUpdateErrors, ThrowOnError>({
        url: '/onboarding',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark the tutorial as completed for the authenticated user
 */
export const tutorialComplete = <ThrowOnError extends boolean = false>(options?: Options<TutorialCompleteData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TutorialCompleteResponses, TutorialCompleteErrors, ThrowOnError>({
        url: '/tutorial/complete',
        ...options
    });
};

export const userIndex = <ThrowOnError extends boolean = false>(options?: Options<UserIndexData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserIndexResponses, UserIndexErrors, ThrowOnError>({
        url: '/users',
        ...options
    });
};

export const userDelete = <ThrowOnError extends boolean = false>(options: Options<UserDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UserDeleteResponses, UserDeleteErrors, ThrowOnError>({
        url: '/users/{id}',
        ...options
    });
};

export const userShow = <ThrowOnError extends boolean = false>(options: Options<UserShowData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserShowResponses, UserShowErrors, ThrowOnError>({
        url: '/users/{id}',
        ...options
    });
};

export const userUpdate = <ThrowOnError extends boolean = false>(options: Options<UserUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UserUpdateResponses, UserUpdateErrors, ThrowOnError>({
        url: '/users/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};